export function BulkActionsBar({ selectedCount, onBulkAction }) {
  if (selectedCount === 0) return null;

  return (
    <div className="mt-4 bg-[#F5F3FF] dark:bg-[#2A2440] border border-[#62397f] dark:border-[#7C3AED] rounded-xl p-4">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <span className="text-sm font-medium text-[#111111] dark:text-white font-inter">
          {selectedCount} {selectedCount === 1 ? "category" : "categories"}{" "}
          selected
        </span>
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => onBulkAction("activate")}
            className="px-4 py-2 bg-white dark:bg-[#1A1A1A] border border-[#E5E7EB] dark:border-[#2A2A2A] text-[#111111] dark:text-white rounded-lg text-sm font-medium font-inter transition-all hover:bg-[#F9FAFB] dark:hover:bg-[#262626] active:scale-95"
          >
            Activate
          </button>
          <button
            onClick={() => onBulkAction("disable")}
            className="px-4 py-2 bg-white dark:bg-[#1A1A1A] border border-[#E5E7EB] dark:border-[#2A2A2A] text-[#111111] dark:text-white rounded-lg text-sm font-medium font-inter transition-all hover:bg-[#F9FAFB] dark:hover:bg-[#262626] active:scale-95"
          >
            Disable
          </button>
          <button
            onClick={() => onBulkAction("delete")}
            className="px-4 py-2 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-600 dark:text-red-400 rounded-lg text-sm font-medium font-inter transition-all hover:bg-red-100 dark:hover:bg-red-900/30 active:scale-95"
          >
            Delete Empty
          </button>
        </div>
      </div>
    </div>
  );
}
